import React, { useState, useEffect } from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';

import img from '../../assets/images/logo/log-footer.png';
import img1 from '../../assets/images/logo/logo-footer-dark.png';

function Footer() {
  const [productLink] = useState([
    {
      title: 'Twitter',
      path: 'https://x.com/oscartrash2gold',
    },
    {
      title: 'Telegram',
      path: 'https://t.me/oscartrash2gold',
    },
    {
      title: 'Discord',
      path: 'https://discord.com/invite/JZYcxRv2',
    },
    {
      title: 'Docs',
      path: 'https://oscarmeme.gitbook.io/oscar',
    }
  ]);
  const [servicesLink] = useState([
    {
      title: 'Privacy Policy',
      path: '/privacy-policy',
    },
    {
      title: 'Terms of Use',
      path: '/terms-of-use',
    },
  ]);
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <footer className="footer style-2">
      <div className="container">
        <div className="footer__main">
          <div className="row">
            <div className="col-xl-4 col-md-8">
              <div className="info">
                <Link to="/" className="logo light">
                  <img src={img} alt="" />
                </Link>
                <Link to="/" className="logo dark">
                  <img src={img1} alt="" />
                </Link>
                <h6>Let's talk! 🤙</h6>
                <ul className="list">
                  <li>
                    <p>We are all ears on</p> <a href="https://discord.com/invite/JZYcxRv2" target='_blank'>Discord</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-md-4">
              <div className="widget">
                <div className="widget-link">
                  <h6 className="title">Follow Us</h6>
                  <ul>
                    {productLink.map((data, idx) => (
                      <li key={idx}>
                        <a href={data.path} target="_blank" rel="noopener noreferrer">{data.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="widget-link s2">
                  <h6 className="title">Links</h6>
                  <ul>
                    {servicesLink.map((data, idx) => (
                      <li key={idx}>
                        <a href={data.path} target="_blank" rel="noopener noreferrer">{data.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-12">
              <div className="footer-contact">
                <h5>Newsletters</h5>
                <p>
                  Get regular updates on our activities, latest news on
                  compliance and regulations in DeFi.
                </p>
                <form action="#" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    required
                    style={{
                      backgroundColor: '#1e1e1e',
                      color: '#fff',
                      border: '1px solid #efbc00',
                      borderRadius: '8px',  
                      padding: '12px 16px',
                      width: '100%',
                      fontSize: '16px',
                    }}
                  />
                  <button
                    type="submit"
                    style={{
                      backgroundColor: '#119f24',
                      color: '#000',
                      border: 'none',
                      borderRadius: '8px',  
                      fontWeight: '600',
                      cursor: 'pointer',
                    }}
                  >
                    Submit
                  </button>
                </form>


              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="footer__bottom">
          <p>
            ©2025 OSCAR. All rights reserved.{' '}
            <a href="/terms-of-use"  >
              Terms of Use
            </a>{' '}
            |{' '}
            <a href="/privacy-policy" >
              Privacy Policy
            </a>
          </p>
        </div>
      </div>

      {isVisible && <Link onClick={scrollToTop} to="#" id="scroll-top"></Link>}
    </footer>
  );
}

export default Footer;
